import { Component } from '../../../libs/gin-tonic/helpers/compiler';

@Component({ className: 'js-event' })
export class EventExpandComponent {
	constructor(private element: HTMLElement) {
		const titleHeight = this.element.querySelector('.js-event-title')?.clientHeight ?? 0;
		this.element.querySelector('.js-event-description')?.setAttribute('style', `-webkit-line-clamp:${titleHeight > 50 ? 1 : 2}`);
		this.element.querySelector('.js-event-duration')?.classList.add('hidden');
		this.element.querySelector('.js-event-location')?.classList.add('hidden');
		this.element.querySelector('.js-event-link')?.classList.add('hidden');
		this.onEventClick();
	}

	onEventClick() {
		this.element.addEventListener('click', () => {
			if (this.element.classList.contains('expanded')) {
				const titleHeight = this.element.querySelector('.js-event-title')?.clientHeight ?? 0;
				this.element.querySelector('.js-event-description')?.setAttribute('style', `-webkit-line-clamp:${titleHeight > 50 ? 1 : 2}`);
				this.element.querySelector('.js-event-duration')?.classList.add('hidden');
				this.element.querySelector('.js-event-location')?.classList.add('hidden');
				this.element.querySelector('.js-event-link')?.classList.add('hidden');
				this.element.removeAttribute('style');
			} else {
				this.element.querySelector('.js-event-description')?.removeAttribute('style');
				this.element.querySelector('.js-event-duration')?.classList.remove('hidden');
				this.element.querySelector('.js-event-location')?.classList.remove('hidden');
				this.element.querySelector('.js-event-link')?.classList.remove('hidden');
				this.element.setAttribute('style', `height:${this.element.scrollHeight}px;`);
			}
			this.element.classList.toggle('expanded');
		});
	}
}
